import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PortalLayout = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    // Get customer info from localStorage
    const customerUser = JSON.parse(localStorage.getItem('customerUser') || '{}');

    const handleLogout = () => {
        // Clear customer token and user data
        localStorage.removeItem('customerToken');
        localStorage.removeItem('customerUser');
        navigate('/portal/login');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <div className="min-h-screen bg-gray-50 font-sans">
            {/* Simple Header */}
            <header className="bg-white shadow">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16">
                        <div className="flex items-center gap-8">
            <div className="flex items-center">
              <span className="text-2xl font-bold text-blue-600">{t('common.appName')}</span>
              <span className="ml-2 text-sm text-gray-500 border-l pl-2 border-gray-300">{t('portal.title')}</span>
            </div>
                            <nav className="flex gap-4">
                                <Link
                                    to="/portal/dashboard"
                                    className={`px-3 py-2 text-sm font-medium rounded-md ${
                                        isActive('/portal/dashboard')
                                            ? 'bg-blue-100 text-blue-700'
                                            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                                    }`}
                                >
                                    Dashboard
                                </Link>
                                <Link
                                    to="/portal/settings"
                                    className={`px-3 py-2 text-sm font-medium rounded-md ${
                                        isActive('/portal/settings')
                                            ? 'bg-blue-100 text-blue-700'
                                            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                                    }`}
                                >
                                    Settings
                                </Link>
                            </nav>
                        </div>
                        <div className="flex items-center gap-4">
                            <span className="text-sm text-gray-600">
                                Welcome, {customerUser.fullName || 'Customer'}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="text-sm text-red-600 hover:text-red-800 font-medium"
                            >
                                Sign out
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <Outlet />
            </main>

            {/* Simple Footer */}
            <footer className="bg-white border-t border-gray-200 mt-auto">
                <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <p className="text-center text-sm text-gray-500">
                        � {new Date().getFullYear()} United Exchange.
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default PortalLayout;
